import React, { useState } from 'react';
import { Tr, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

import { DetailsDropdown } from '../../views/Users/index.jsx';

import { MerchantOverview } from './MerchantOverview';
import { MerchantRequests } from './MerchantRequests';
import { MerchantListings } from './MerchantListings';

export function MerchantDetailsRow({ onMerchantUpdated, merchant }) {
  const [activeTab, setActiveTab] = useState('overview')

  const tabs = [
    {
      'id': 'overview',
      'label': 'Overview',
      'component': MerchantOverview,
    },
    {
      'id': 'requests',
      'label': 'Requests',
      'component': MerchantRequests,
    },
    {
      'id': 'listings',
      'label': 'Listings',
      'component': MerchantListings,
    },
  ]

  const contentProps = {
    merchant,
    afterSubmit: onMerchantUpdated,
  };

  const ContentComponent = tabs.find((t) => t.id === activeTab)?.component

  const onTabChange = (tabId) => {
    setActiveTab(tabId)
  }

  return (
    <Tr>
      <Td className="details merchant-row-details" colSpan={8}>
        <div className="contact-details-container px-0 px-xxl-4">
          <DetailsDropdown tabs={tabs} activeTab={activeTab} onChange={onTabChange} />

          <div className="content mx-2">
            {ContentComponent ? <ContentComponent {...contentProps} /> : null}
          </div>
        </div>
      </Td>
    </Tr>
  );
}
